module.exports = __webpack_public_path__ + "img/honnor3.a5dd6104.png";